{
  "eyebrow": "Confirm your plan",
  "title": "Review and configure.",
  "sub": "You can change billing cycle or switch plans anytime from your admin dashboard.",
  "yourPlan": "Your plan",
  "changePlan": "Change plan",
  "billing": "Billing cycle",
  "billingMonthLabel": "Pay monthly",
  "billingMonthDesc": "Flexible. Cancel anytime.",
  "billingYearLabel": "Pay annually",
  "billingYearDesc": "15% off. Billed once a year.",
  "addons": "Add-ons",
  "addon": {
    "ssec": "Social security (check-in/out@work)",
    "ssecDesc": "Belgium only — automatic Dimona declaration.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Live GPS for company vehicles. +€4 / vehicle / month.",
    "vehicles": "Vehicles"
  },
  "employees": {
    "title": "How many employees?",
    "active": "users",
    "popular": "Most teams pick {{n}}"
  },
  "estimate": "Estimated monthly cost",
  "estimateNote": "Excluding VAT. You pay for the number of users you set here, and you can change it later.",
  "estimateUnavailable": "Price catalog unavailable. Retry to load the latest pricing."
}
